import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
import { addDays, startOfDay } from 'date-fns';
import type { StepDirection } from './types';

const MAP_DAY_OPTIONS = [1, 2, 3, 4, 5, 6, 7];

/** Default map window — a week, matching the original Map View story. */
export const MAP_DAYS_DEFAULT = 7;

interface MapViewControlsProps {
  mapDays: number;
  onMapDaysChange: (days: number) => void;
}

/**
 * Day-range selector for Map view (1–7 days). Mirrors the Grid day selector so
 * the two views feel consistent; the chosen span windows which scheduled jobs
 * appear as markers.
 */
export function MapViewControls({ mapDays, onMapDaysChange }: MapViewControlsProps) {
  return (
    <Select value={mapDays.toString()} onValueChange={(value) => onMapDaysChange(parseInt(value))}>
      <SelectTrigger className="w-[140px] bg-background border-border text-foreground h-8">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border">
        {MAP_DAY_OPTIONS.map((days) => (
          <SelectItem key={days} value={days.toString()}>
            {days} {days === 1 ? 'day' : 'days'}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function mapRangeStart(cursor: Date): Date {
  return startOfDay(cursor);
}

/** Page the map by the selected window so prev/next lines up with the range. */
export function mapStepDate(cursor: Date, direction: StepDirection, mapDays: number): Date {
  return addDays(cursor, direction * mapDays);
}
